import * as API from '../'
export default {
    getList:params =>{
        return API.GET('/api/deviceSupplier/list',params)
    },
    insert:params=>{
        return API.postJsonRequest('/api/deviceSupplier/insert',params)
    },
    update:params=>{
        return API.postJsonRequest('/api/deviceSupplier/update',params)
    },
    remove: id => {
        return API.GET('/api/deviceSupplier/remove/' + id)
    },
}


// WEBPACK FOOTER //
// ./src/api/device/api_deviceSupplier.js